import { Grid } from "@mui/material";
import { FormikProps } from "formik";
import { forwardRef } from "react";
import { AsyncSelectOption } from "@/components/AsyncSelect";
import FormSection from "@/components/FormSection";
import ProviderSelect from "@/components/ProviderSelect";
import { UseProvidersListProps } from "@/queries/provider/setting/use-providers-list";
import { DEF_PAGINATION } from "@/utils/utils";
import { GROUP_LABEL, GROUP_SECTION } from "../group-visit-constant";
import { GroupFormValues } from "../group-visit-types";

export type ProviderAssignmentSectionProps = {
  formik: FormikProps<GroupFormValues>;
  disabled?: boolean;
};

/**
 * Only active providers of the practice are listed; staff users are excluded.
 *
 * @author Rajkumar Rathod
 */
const PROVIDER_SEARCH_PARAM: UseProvidersListProps = {
  pagination: DEF_PAGINATION,
  status: true,
};

const ProviderAssignmentSection = forwardRef<
  HTMLDivElement,
  ProviderAssignmentSectionProps
>(({ formik, disabled }, ref) => {
  const { values, errors, touched, setFieldValue, handleBlur } = formik;

  return (
    <FormSection
      variant="plain"
      ref={ref}
      id={GROUP_SECTION.PROVIDER}
      title={GROUP_LABEL.providerSection}
    >
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <ProviderSelect
            label={GROUP_LABEL.primaryTherapist}
            required
            name="primaryTherapist"
            disabled={disabled}
            value={values.primaryTherapist as AsyncSelectOption | null}
            handleBlur={handleBlur}
            providerSearchParam={PROVIDER_SEARCH_PARAM}
            onChange={(value) => setFieldValue("primaryTherapist", value)}
            error={
              touched.primaryTherapist && (errors.primaryTherapist as string)
            }
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <ProviderSelect
            label={GROUP_LABEL.coTherapist}
            name="coTherapist"
            disabled={disabled}
            value={values.coTherapist as AsyncSelectOption | null}
            handleBlur={handleBlur}
            providerSearchParam={PROVIDER_SEARCH_PARAM}
            onChange={(value) => setFieldValue("coTherapist", value)}
            error={touched.coTherapist && (errors.coTherapist as string)}
          />
        </Grid>
      </Grid>
    </FormSection>
  );
});

ProviderAssignmentSection.displayName = "ProviderAssignmentSection";

export default ProviderAssignmentSection;
